export const FEATURE_LICENSE_CODES = ['FEATURE_NOT_AVAILABLE', 'MODULE_NOT_LICENSED'] as const;

export type FeatureLicenseCode = (typeof FEATURE_LICENSE_CODES)[number];

export interface AccessErrorResponse {
  error?: string;
  detail?: string;
  title?: string;
  message?: string;
  code?: string;
}

export interface FeatureLicenseError {
  code: FeatureLicenseCode;
  message: string;
}

const DEFAULT_FEATURE_MESSAGE = 'Esta funcionalidade não está disponível no plano atual.';

export function isFeatureLicenseCode(code: string | undefined): code is FeatureLicenseCode {
  return !!code && FEATURE_LICENSE_CODES.includes(code as FeatureLicenseCode);
}

export function readAccessErrorMessage(data: AccessErrorResponse): string {
  return data.detail || data.error || data.message || data.title || '';
}

export function parseFeatureLicenseError(data: unknown): FeatureLicenseError | null {
  if (typeof data !== 'object' || data === null)
  {
    return null;
  }

  const response = data as AccessErrorResponse;

  if (!isFeatureLicenseCode(response.code))
  {
    return null;
  }

  return {
    code: response.code,
    message: readAccessErrorMessage(response) || DEFAULT_FEATURE_MESSAGE,
  };
}

export function extractAccessErrorMessage(error: unknown): string {
  const axiosError = error as { response?: { status?: number; data?: unknown } };
  const status = axiosError.response?.status;
  const data = axiosError.response?.data;

  if (status !== 403)
  {
    return '';
  }

  return parseFeatureLicenseError(data)?.message || '';
}
